import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_API_URL}/Common`;

export default {        
    uploadFile: async (file) => {
        let user = JSON.parse(localStorage.getItem('login_info'));

        var headers = new Headers();
        headers.append("Authorization", `Bearer ${user.accessToken}`);

        var formdata = new FormData();
        formdata.append("file", file, file.name);

        var requestOptions = {
            method: 'POST',
            headers: headers,
            body: formdata
        };

        let rs = await fetch(`${mainUrl}/UploadFile`, requestOptions);
        return await common.handleResponse(rs);
    },

    deleteFile: async (path) => {
        const requestOptions = {
            method: 'DELETE',
            headers: await header.authHeaderWithToken(),
        };
    
        let rs = await fetch(`${mainUrl}/DeleteFile?path=${path}`, requestOptions);
        return await common.handleResponse(rs);
    },
}